import * as React from "react";
import Popover from "@mui/material/Popover";
import { makeStyles } from "@material-ui/core/styles";
import IconCheck from "@material-ui/icons/Check";
import TextField from '@mui/material/TextField';
import { Grid, Typography } from "@material-ui/core";
import {MuiPickersUtilsProvider,TimePicker} from '@material-ui/pickers';
import moment from 'moment';
import {Close,ArrowDropUp,ArrowDropDown} from '@material-ui/icons'
import { momentToHrs } from "../../../../helpers/date.helper";
import DateFnsUtils from "@date-io/date-fns";

const useStyles =makeStyles({
  datePicker: {
      '& .MuiPickersModal-dialog': {
          backgroundColor: 'var(--dark) !important'
      },
      '& .MuiDialogActions-spacing ': {
        backgroundColor: 'var(--darker) !important'
    },
    '& .MuiDialogActions-spacing .MuiButton-label': {
      color:'var(--darker)'
  },
    '& .MuiPickersModal-dialog .MuiPickersBasePicker-container .MuiToolbar-root': {
      backgroundColor: 'var(--darker)  !important'
  },
  
  }
})


export default function TimeRange(props) {
  const classes=useStyles();
 
  const [anchorEl, setAnchorEl] = React.useState(null);
  // const [minTime,setMinTime]=React.useState(new Date()); 
  // const [maxTime,setMaxTime]=React.useState(new Date());
  // const [isSet,setIsSet]=React.useState(false)

  // const momentToHrs=(date)=>
  // {
  //   if(typeof date!=Date)
  //   date=new Date()
  //   let hours=date.getHours();
  //   let minutes=date.getMinutes()
  //   if (hours < 10) { hours = "0" + hours; }
  //   if (minutes < 10) { minutes = "0" + minutes; }
  //   let datef=`${hours}:${minutes}`;
  //   return datef;
  // }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMinUpdate=(val)=>{
    // setIsSet(true);
    handleChange({min:val,max:props.value.max})
    //  setMinTime(val);
  }

  const handleMaxUpdate=(val)=>{

    // setIsSet(true);
    handleChange({min:props.value.min,max:val})
    //  setMaxTime(val);
  }

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleChange=(val)=>{
    if(props.onChange)
    props.onChange(val);
  }

// React.useEffect(()=>{
//   if(JSON.stringify(props.value)!=JSON.stringify(props.defaultValue))
//   setIsSet(true)
// },[props.value])

 const handleClear=(e)=>{
  e.stopPropagation()
  handleChange({min:"",max:""})
  handleReset();
  // setIsSet(false);
}
const handleReset=()=>
{
 if(props.onReset)
 props.onReset();
}

  return (
    <div>
           <div className="filter-button" onClick={handleClick}>
           <Typography component="span"  className="filter-text">  {props.used?`${momentToHrs(props.value.min)} - ${momentToHrs(props.value.max)}`:props.label }</Typography>

        <Typography variant="span" className="filter-arrow">
            {open?<ArrowDropUp/>:<ArrowDropDown/>}
        </Typography>
        {props.used?   <Typography className="icon-close" variant="a" style={{fontSize:'18px'}} onClick={handleClear}><Close/></Typography>:""}
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >        
        <div style={{width:'350px',padding:'30px 25px',backgroundColor:'var(--backgroundcolor)',borderRadius:'5px'}}>   
        <div style={{marginBottom:'5px'}}>
             
      <Typography component="span" style={{textAlign:'left',color:'var(--darker)'}}>{props.label}</Typography>
          </div>
      <Grid container className="my-time-range-picker">
                <Grid item xs="6" md="6">

        <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <TimePicker DialogProps={{ className: classes.datePicker }} 
        label="Min Time"
         value={props.value.min!=""?props.value.min:new Date()}
        //  ampm={false}
        onChange={handleMinUpdate}
        renderInput={(params) => <TextField {...params} />}
      />
  </MuiPickersUtilsProvider>  
  </Grid>
  <Grid item xs="6" md="6">
  <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <TimePicker DialogProps={{ className: classes.datePicker }} 
        label="Max Time"
        value={props.value.max!=""?props.value.max:new Date()}
        // ampm={false}
        onChange={handleMaxUpdate}
        renderInput={(params) => <TextField {...params} />}
      />
    </MuiPickersUtilsProvider>     
    </Grid>
    </Grid>
        </div>
      </Popover>
    </div>
  );
}

TimeRange.defaultProps={
  value:{min:new Date(),max:new Date()}
}

